import * as React from 'react';

export const EditAIFeed = React.lazy(() => import('./EditAIFeed'));
